
<template>
  <div class="inOutRank">
    <div class="content-container">
      <div class="titieMian">
        <div class="title-container">收支排行榜</div>
        <!-- <div class="select-container" style="display:flex;justify-content:flex-end;padding-right:40px;padding-top:10px;"> -->
          <!-- <div class="select-container-box" >
            <span>年度&nbsp;</span>
            <el-select  filterable placeholder="请选择" size="small" v-model="year" style="" @change="changeYear">
              <el-option
                v-for="(item, index) in yearList"
                 :key="index" 
                :label="item.name" 
                :value="item.name">
              </el-option>
            </el-select>
          </div> -->
        <div class="select-container" style="z-index:9999" >
          <div class="select-container-box tab">
            <el-select v-model="memoryValue" size="small" placeholder="请选择" @change="changeBatDateList">
              <el-option
                v-for="item in batDateList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box" v-if="memoryValue=='date'">
            <!-- <span>时间&nbsp;&nbsp;</span> -->
            <el-date-picker
              size="small"
              v-model="start"
              type="date"
              :clearable="false"
              placeholder="开始日期"
              value-format="yyyy-MM-dd"
              @change="changeTime(0)"
              :picker-options="pickerTimeOptions">
            </el-date-picker>
            <span>至</span>
            <el-date-picker
              size="small"
              v-model="end"
              type="date"
              :clearable="false"
              placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="changeTime(1)"
              :picker-options="pickerTimeOptions">
            </el-date-picker>
          </div>
          <div class="select-container-box"  v-if="memoryValue=='Batch'">
            <!-- <span>周期&nbsp;&nbsp;</span> -->
            <el-select v-model="batch" size="small"  placeholder="请选择" @change="batchChange">
              <el-option
                v-for="item in batchList"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box">
            <el-button size="small"  type="info" plain @click="search" class="query">查询</el-button>
          </div>
        </div>
         
      </div>
      <div class="table-container" style="margin-top:-7px;border-top:none;">
        <div class="rank">
           <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="基地排名" name="first">
              <el-table
                :data="tableData"
                :empty-text="getEmptyText('first')"
                stripe
                style="width: 100%">
                <el-table-column
                  type="index"
                  width="150"
                  align="center"
                  label="排名"
                >
                </el-table-column>
                <el-table-column
                  prop="typeName"
                  label="基地"
                  align="center"
                  show-overflow-tooltip
                  >
                </el-table-column>
                <el-table-column
                  prop="area"
                  label="面积(亩)"
                  align="center"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                  prop="headName"
                  label="负责人"
                  align="center"
                  show-overflow-tooltip>
                </el-table-column>
                  <el-table-column
                  prop="productionNum"
                  label="产量(斤)"
                  align="center"
                  show-overflow-tooltip
                  >
                  <template slot-scope="scope">
                    <span>
                      {{scope.row.productionNum.toFixed(2)}}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="productionValue"
                  label="产值"
                  align="center"
                  show-overflow-tooltip
                >
                <template slot-scope="scope">
                  <span>
                    {{scope.row.productionValue.toFixed(2)}}
                  </span>
                </template>
                </el-table-column>
                <el-table-column
                  prop="coefficient"
                  label="饵料系数"
                  align="center"
                  show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span>
                      {{scope.row.coefficient.toFixed(2)}}
                    </span>
                  </template>
                </el-table-column>
                  <el-table-column
                  prop="areabenefits"
                  label="亩产效益"
                  align="center"
                  show-overflow-tooltip
                  >
                  <template slot-scope="scope">
                    <span>
                      {{scope.row.areabenefits.toFixed(2)}}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="payback"
                  label="投资回报率"
                  align="center"
                  show-overflow-tooltip
                >
                <template slot-scope="scope">
                  <span>
                    {{scope.row.payback.toFixed(2)}}
                  </span>
                </template>
                </el-table-column>
              
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="塘口排名" name="second">
              <el-table
                :data="tableData1"
                :empty-text="getEmptyText('second')"
                stripe
                style="width: 100%">
                <el-table-column
                  type="index"
                  width="150"
                  align="center"
                  label="排名"
                >
                </el-table-column>
                <el-table-column
                  prop="typeName"
                  label="塘口"
                  align="center"
                  show-overflow-tooltip
                  >
                </el-table-column>
                <el-table-column
                  prop="area"
                  label="面积(亩)"
                  align="center"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                  prop="headName"
                  label="负责人"
                  align="center"
                  show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                prop="productionNum"
                label="产量(斤)"
                align="center"
                show-overflow-tooltip
                >
                <template slot-scope="scope">
                  <span>
                    {{scope.row.productionNum.toFixed(2)}}
                  </span>
                </template>
                </el-table-column>
                <el-table-column
                  prop="productionValue"
                  label="产值"
                  align="center"
                  show-overflow-tooltip
                >
                <template slot-scope="scope">
                  <span>
                    {{scope.row.productionValue.toFixed(2)}}
                  </span>
                </template>
                </el-table-column>
                <el-table-column
                  prop="coefficient"
                  label="饵料系数"
                  align="center"
                  show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span>
                      {{scope.row.coefficient.toFixed(2)}}
                    </span>
                  </template>
                </el-table-column>
                  <el-table-column
                  prop="areabenefits"
                  label="亩产效益"
                  align="center"
                  show-overflow-tooltip
                  >
                  <template slot-scope="scope">
                    <span>
                      {{scope.row.areabenefits.toFixed(2)}}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="payback"
                  label="投资回报率"
                  align="center"
                  show-overflow-tooltip
                >
                <template slot-scope="scope">
                  <span>
                    {{scope.row.payback.toFixed(2)}}
                  </span>
                </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="负责人排名" name="third">
              <el-table
                :data="tableData2"
                :empty-text="getEmptyText('third')"
                stripe
                style="width: 100%">
                <el-table-column
                  type="index"
                  width="150"
                  align="center"
                  label="排名"
                >
                </el-table-column>
                <el-table-column
                  prop="typeName"
                  label="塘口负责人"
                  align="center"
                  show-overflow-tooltip
                  >
                </el-table-column>
                <el-table-column
                  prop="area"
                  label="面积(亩)"
                  align="center"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                  prop="productionNum"
                  label="产量(斤)"
                  align="center"
                  show-overflow-tooltip
                >
                <template slot-scope="scope">
                  <span>
                    {{scope.row.productionNum.toFixed(2)}}
                  </span>
                </template>
                </el-table-column>
                <el-table-column
                  prop="productionValue"
                  label="产值"
                  align="center"
                  show-overflow-tooltip
                >
                <template slot-scope="scope">
                  <span>
                    {{scope.row.productionValue.toFixed(2)}}
                  </span>
                </template>
                </el-table-column>
                <el-table-column
                  prop="coefficient"
                  label="饵料系数"
                  align="center"
                  show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span>
                      {{scope.row.coefficient.toFixed(2)}}
                    </span>
                  </template>
                </el-table-column>
                  <el-table-column
                  prop="areabenefits"
                  label="亩产效益"
                  align="center"
                  show-overflow-tooltip
                  >
                  <template slot-scope="scope">
                    <span>
                      {{scope.row.areabenefits.toFixed(2)}}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="payback"
                  label="投资回报率"
                  align="center"
                  show-overflow-tooltip
                >
                <template slot-scope="scope">
                  <span>
                    {{scope.row.payback.toFixed(2)}}
                  </span>
                </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { modules } from "../../store";
import { MessageBox, Message } from "element-ui";
import { storage } from "../../service/storage";
import checkPermission from "../../service/checkPermission.js";
import mixins from "@/common/MixIn.js";

export default {
  mixins: [mixins],
  name: "InOutRank",
  data() {
    return {
      memoryValue: "date",
      batDateList: [
        {
          value: "Batch",
          label: "周期"
        },
        {
          value: "date",
          label: "时间"
        }
      ],
      start: "",
      end: "",
      batch: "",
      batchList: [],
      activeName: "first",
      tableData: [],
      tableData1: [],
      tableData2: [],
      year: "2020",

      pickerTimeOptions: {
        // 限制日期
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        }
      },
      payment: 1,
      queryLoading: false,
      yearList: [
        {
          id: 1,
          name: 2017
        },
        {
          id: 2,
          name: 2018
        },
        {
          id: 3,
          name: 2019
        },
        {
          id: 4,
          name: 2020
        },
        {
          id: 5,
          name: 2021
        },
        {
          id: 6,
          name: 2022
        },
        {
          id: 7,
          name: 2023
        },
        {
          id: 8,
          name: 2024
        },
        {
          id: 9,
          name: 2025
        }
      ]
    };
  },
  //默认时间
  created() {
    let startTime = storage.get("start");
    let endTime = storage.get("end");
    if (startTime) {
      this.start = startTime;
    } else {
      const start = new Date();
      start.setDate(1);
      this.start = this.$timeformatDay(start);
    }
    if (endTime) {
      this.end = endTime;
    } else {
      this.end = this.$timeformatDay(new Date());
    }
  },
  async mounted() {
    this.judgeChoose();
    await this.getBatch();
    await this.search();
    checkPermission.checkEdit(this.$route).then(data => {
      this.edit = data;
    });

  },
  watch: {
    activeName(val) {
      if (val == "first") {
        this.payment = 1;
        this.getData(this.payment);
      } else if (val == "second") {
        this.payment = 2;
        this.getData(this.payment);
      } else if (val == "third") {
        this.payment = 4;
        this.getData(this.payment);
      }
    }
  },
  methods: {
    ...mapActions(modules.inOutRank, {
      getInOutRank: "getInOutRank" //收支排行榜
    }),
    ...mapActions(modules.cultureCycle, {
      getBatchList: "getBatchList" //周期下拉
    }),
    // 获取周期下拉
    async getBatch() {
      this.batchList = await this.getBatchList();
      this.batchList.unshift("全部");
      this.batch = "全部";
    },
    // 判断localstorage 是周期还是时间
    judgeChoose() {
      let memoryValue = localStorage.getItem("memoryValue");
      if (memoryValue) {
        this.memoryValue = memoryValue;
      } else {
        this.memoryValue = this.memoryValue;
      }
      if (this.memoryValue == "Batch") {
        // this.start = "";
        // this.end = "";
        this.batch = "全部";
      } else if (this.memoryValue == "date") {
        this.batch = "";
      }
    },
    //切换时间和周期
    changeBatDateList(e) {
      localStorage.setItem("memoryValue", e);
      console.log(e);
      if (e == "Batch") {
        // this.start = "";
        // this.end = "";
        this.batch = "全部";
      } else if (e == "date") {
        this.batch = "";
      }
    },
    //周期切换
    batchChange(e) {
      if (e) {
        this.batch = e;
        this.search();
      }
    },
    //存储选中时间
    changeTime(type) {
      if (type == 0) {
        storage.set("start", this.start);
      } else {
        storage.set("end", this.end);
      }
    },
    getEmptyText(tabName) {
      return this.queryLoading && this.activeName === tabName ? "查询中" : "暂无数据";
    },
    clearTableData(payment) {
      if (payment == 1) {
        this.tableData = [];
      } else if (payment == 2) {
        this.tableData1 = [];
      } else if (payment == 4) {
        this.tableData2 = [];
      }
    },
    setTableData(payment, data) {
      if (payment == 1) {
        this.tableData = data;
      } else if (payment == 2) {
        this.tableData1 = data;
      } else if (payment == 4) {
        this.tableData2 = data;
      }
    },
    async fetchRankData(payment) {
      this.queryLoading = true;
      this.clearTableData(payment);
      try {
        const inOutRank = await this.getInOutRank({
          payment,
          batch: this.batch == "全部" ? "" : this.batch,
          startDate: this.memoryValue == "date" ? this.start : "",
          endDate: this.memoryValue == "date" ? this.end : ""
        });
        this.setTableData(payment, inOutRank || []);
      } finally {
        this.queryLoading = false;
      }
    },
    async getData(num) {
      this.payment = num;
      await this.fetchRankData(num);
    },
    async search() {
      const paymentMap = { first: 1, second: 2, third: 4 };
      await this.fetchRankData(paymentMap[this.activeName]);
    },
    handleClick(tab, event) {
      // console.log(tab, event);
    }
  }
};
</script>
<style lang="stylus" >
.inOutRank
  .tab
    .el-select
      width 100px !important
      min-width 100px !important
    .el-input--small
      width 100px !important
      min-width 100px !important

  .select-container-box:nth-child(1)
    .el-input--small
      /* width 100px!important */
      height 38px!important
      min-width 100px!important
      border-radius:4px;
      z-index:999;
  //  .select-container-box:nth-child(1)
  //   .el-input--small
  //     width 135px!important
  //     height 38px!important
  //     min-width 135px!important
  .table-container
  // 选项卡切换样式
    .rank
      // margin-top:-40px;
      .el-table--striped .el-table__body tr.el-table__row--striped td
        background: #F2F9FF!important;
      .el-tabs__content .el-tab-pane 
        .el-table
          .el-table__row:nth-of-type(even)
            background rgba(242, 249, 255, 1)!important;
      .el-table
        margin-top:50px;
      
        tbody
          >tr.el-table__row:first-child
            .cell
              height: 100%;
              line-height: 37px;
              >div:first-child
                height: 100%;
                background:url('../../../public/img/icon_first.png') no-repeat 50%;
                color:rgba(0,0,0,0.0001);
          >tr:nth-child(2)
            .cell
              height: 100%;
              line-height: 37px;
              >div
                height: 100%;
                background:url('../../../public/img/icon_second.png') no-repeat 50%;
                color:rgba(0,0,0,0.0001);
          >tr:nth-child(3)
            .cell
              height: 100%;
              line-height: 37px;
              >div
                height: 100%;
                background:url('../../../public/img/icon_third.png') no-repeat 50%;
                color:rgba(0,0,0,0.0001);
      
      .el-tabs__nav
        white-space: nowrap;
        position: relative;
        left: 620px!important;
        .el-tabs__item
          font-size:16px;
          font-family:MicrosoftYaHei;
          font-weight:400;
          color:rgba(102,102,102,1);
        .el-tabs__item.is-active
          font-size:16px;
          font-family:MicrosoftYaHei-Bold;
          font-weight:bold;
          color:rgba(51,137,255,1);
        .el-tabs__active-bar
          position: absolute;
          bottom: 0;
          left: 0;
          width:120px;
          height:2px;
          background:rgba(51,137,255,1);
        .el-tabs__nav-wrap::after
          content: "";
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height:1px;
          background:rgba(204,210,218,1);
          z-index: 1;

      
</style>
